<template>
	<div>
		<div class="md:flex">
			<div class="md:w-1/3 md:pr-4 lg:pr-20">
				<h2 class="font-semibold text-xl mb-2">Shipping Address</h2>
				<div class="bg-white rounded-lg p-4">
					<AddressBox :address="shippingAddress" :allowActions="false" />
				</div>
			</div>
			<div class="md:w-1/3 md:pr-4 lg:pr-20">
				<h2 class="font-semibold text-xl my-2 md:mt-0 md:mb-2">Billing Address</h2>
				<div class="bg-white rounded-lg p-4">
					<AddressBox :address="billingAddress" :allowActions="false" />
				</div>
			</div>
			<div class="md:w-1/3 md:pr-4 lg:pr-20">
				<h2 class="font-semibold text-xl my-2 md:mt-0 md:mb-2">Payment Method</h2>
				<div class="bg-white rounded-lg p-4">
					<p>Payment Type: {{ summary.orderDetails.payment.paymentMethod }}</p>
				</div>
			</div>
		</div>
		<div class="py-8">
			<div class="overflow-x-auto">
				<table class="w-full">
					<thead>
						<tr class="border-b text-lg">
							<th class="text-left py-3 font-medium">
								<p class="w-48 md:w-auto">Product Name</p>
							</th>
							<th class="text-left px-2 font-medium">
								<p class="w-24 md:w-auto">INCO term</p>
							</th>
							<th class="text-left font-medium">
								<p class="w-24 md:w-auto">Price</p>
							</th>
							<th class="text-left font-medium">
								<p class="w-24 md:w-auto">Quantity</p>
							</th>
							<th class="text-right font-medium">
								<p class="w-24 md:w-auto">Amount</p>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(item, index) in summary.cart"
							:key="`order-summary-${index}`"
							class="hover:bg-gray-300"
						>
							<td class="text-left py-3">
								<router-link class="text-blue-600" :to="`/products/${item.id}`">
									{{ item.name }}
								</router-link>
							</td>
							<td class="text-left px-2">{{ item.incoTerms }}</td>
							<td class="text-left px-2">{{ item.price }}</td>
							<td class="text-left px-2">{{ item.quantity }}</td>
							<td class="text-right">{{ item.subTotal }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<table class="w-full mt-12">
				<tbody>
					<tr class="border-b text-right hover:bg-gray-300">
						<td class="md:w-9/12 py-3">Sub Total</td>
						<td class="md:w-9/12">{{ summary.totals.orderTotal }}</td>
					</tr>
					<tr
						v-if="summary.additionalPurchases.hasPurchasedTesting"
						class="border-b text-right hover:bg-gray-300"
					>
						<td class="md:w-9/12 py-3">Testing by Intertek</td>
						<td class="md:w-9/12">$0.00</td>
					</tr>
					<tr
						v-if="summary.additionalPurchases.hasPurchasedInspection"
						class="border-b text-right hover:bg-gray-300"
					>
						<td class="md:w-9/12 py-3">Inspection by Intertek</td>
						<td class="md:w-9/12">{{summary.totals.inspectionCharges}}</td>
					</tr>
					<tr
						v-if="summary.additionalPurchases.hasPurchasedInsurance"
						class="border-b text-right hover:bg-gray-300"
					>
						<td class="md:w-9/12 py-3">Export Insurance</td>
						<td class="md:w-9/12">{{summary.totals.exportInsurance}}</td>
					</tr>
					<tr
						v-if="summary.additionalPurchases.hasSignedUpForDrs"
						class="border-b text-right hover:bg-gray-300"
					>
						<td class="md:w-9/12 py-3">
							Become verified with DRS by Dun & Bradstreet
						</td>
						<td class="md:w-9/12">{{summary.totals.drsSignUpCharges}}</td>
					</tr>
					<tr class="border-b text-right hover:bg-gray-300">
						<td class="md:w-9/12 py-3 leading-4">
							<p>Platform Fees</p>
							<a
								target="_blank"
								:href="platformFeesURL"
								class="text-sm opacity-75 underline"
							>Why we charge platform fee?</a>
						</td>
						<td class="md:w-8/12">{{ summary.totals.platformCharges }}</td>
					</tr>
					<tr class="text-right hover:bg-gray-300 font-medium text-xl">
						<td class="md:w-8/12 py-3">
							Grand Total
						</td>
						<td class="md:w-8/12">{{ summary.totals.grandTotal }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
import AddressBox from '@/shared/components/profile/address/AddressBox'
import ProductDetails from '@/shared/mixins/ProductDetails'

export default {
	name: 'OrderSummaryTab',
	mixins: [ ProductDetails ],
	props: { summary: { required: true }, cartProducts: { required: true} },
	data() {
		return {
			platformFeesURL: process.env.VUE_APP_PLATFORM_FEES_URL
		}
  },
	components: { AddressBox },
	created() {
		var products = [];
		this.cartProducts.forEach((product) => {
			/*
			window.ga('ec:addProduct', {
				id: product.productId,                            // Transaction ID. Required.
				name: product.name,                       // Product name. Required. 
				sku: product.sku,                        // SKU/code.
				category: product.categoryName,         // Category or variation.
				quantity: product.quantity,
				price : this.calculateItemPrice(product),
				brand: product.brand
			});
			*/
			products.push({
				id: product.productId,                            // Transaction ID. Required.
				name: product.name,                       // Product name. Required. 
				sku: product.sku,                        // SKU/code.
				category: product.categoryName,         // Category or variation.
				quantity: product.quantity,
				price : this.calculateItemPrice(product),
				brand: product.brand
			});
		});
		/*
		window.ga('ec:setAction','checkout', {
			'step': 5,            // A value of 1 indicates this action is first checkout step.
			'option': 'Order Summary'      // Used to specify additional info about a checkout stage, e.g. payment method.
		});
		window.ga('send', 'pageview');
		*/
		window.dataLayer.push({ ecommerce: null });
		window.dataLayer.push({
			'event': 'checkout',
			'ecommerce': {
				'checkout': {
				'actionField': {'step': 5, 'option': 'Order Summary'},
				'products': products
				}
			}
		});
	},
	computed: {
		shippingAddress() {
			return this.summary.orderDetails.shippingAddress
		},
		billingAddress() {
			return this.summary.orderDetails.billingAddress
		}
	}
}
</script>
